function safeText(v: unknown): string {
  if (v == null) return '';
  if (typeof v === 'string') return v;
  if (v instanceof Error) return v.message;
  try {
    return String(v);
  } catch {
    return 'unknown';
  }
}

function escapeHtml(s: string) {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function showFatal(title: string, detail: string) {
  try {
    const root = document.getElementById('root');
    if (!root) return;
    const t = escapeHtml(title);
    const d = escapeHtml(detail);
    root.innerHTML =
      '<div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#282c34;padding:24px;box-sizing:border-box;color:#fff;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif;">' +
      '<div style="max-width:520px;width:100%;background:rgba(255,255,255,0.08);border:1px solid rgba(255,255,255,0.15);border-radius:14px;padding:16px 14px;">' +
      `<div style="font-size:16px;font-weight:700;margin-bottom:10px;">${t}</div>` +
      `<div style="font-size:13px;line-height:1.35;opacity:0.95;white-space:pre-wrap;word-break:break-word;">${d}</div>` +
      '<div style="margin-top:12px;font-size:12px;opacity:0.75;">Сделайте скрин этого текста.</div>' +
      '</div></div>';
  } catch {
    /* ignore */
  }
}

window.addEventListener('error', (e) => {
  const msg = safeText(e.error ?? e.message);
  const src = (e.filename || '') + (e.lineno ? `:${e.lineno}` : '');
  showFatal('Ошибка запуска приложения', msg + (src ? `\n${src}` : ''));
});
window.addEventListener('unhandledrejection', (e) => {
  showFatal('Ошибка запуска приложения', safeText(e.reason));
});

export {};
